import { Card, CardContent, CardHeader, Skeleton } from '@packages/shared';
import { RecoProductCardSkeleton } from '../RecoProductCardSkeleton';
import { RecoCategoryCardSkeleton } from '../RecoCategoryCardSkeleton';
import { RecoBrandCardSkeleton } from '../RecoBrandCardSkeleton';

type RecoCarouseSkeletonProps = {
  /**
   * The type of skeleton cards to display. Default is `PRODUCT`.
   * @default "PRODUCT"
   */
  type?: 'CAT' | 'PRODUCT' | 'BRAND';
};

/**
 * This component can be used to display a skeleton for the recommendations carousel.
 */
export const RecoCarouselSkeleton = ({ type = 'PRODUCT' }: RecoCarouseSkeletonProps) => {
  let skeletonToRender = <RecoProductCardSkeleton />;

  if (type === 'CAT') {
    skeletonToRender = <RecoCategoryCardSkeleton />;
  } else if (type === 'BRAND') {
    skeletonToRender = <RecoBrandCardSkeleton />;
  }
  return (
    <Card>
      <CardHeader
        title={<Skeleton variant="text" width="15%" />}
        sx={{
          borderBottom: 1,
          borderColor: 'grey.main',
          py: 1,
          px: 2,
        }}
      />
      <CardContent
        sx={{
          display: 'flex',
          gap: 1.5,
        }}
      >
        {skeletonToRender}
      </CardContent>
    </Card>
  );
};
